<div [ngClass]="{ block: displayAsBlock(), 'inline-block': !displayAsBlock() }" class="relative">
  <div
    (click)="toggleSelect()"
    [ngClass]="{
      'border-2': theme() === 'STANDARD',
      'font-title-alt text-[25px]': theme() === 'COLORED',
      'bg-purple': theme() === 'COLORED' && selected(),
      'bg-anis': theme() === 'COLORED' && !selected(),
    }"
    class="flex cursor-pointer justify-between gap-x-3 rounded-xl p-3">
    <span class="flex w-full flex-1 justify-start">
      @if (selected(); as selected) {
        {{ selected.label }}
      } @else {
        {{ placeholder() }}
      }
    </span>
    <app-svg [height]="15" [width]="15" class="rotate-90" src="assets/icons/caret-right.svg" />
  </div>
  @if (isOpen()) {
    <ul
      (clickOutside)="isOpen.set(false)"
      [ngClass]="{
        'left-1/2 -translate-x-1/2': dropdownPosition() === 'CENTER',
        'right-0': dropdownPosition() === 'RIGHT',
      }"
      class="absolute z-50 flex w-max min-w-full flex-col gap-y-3 rounded-xl bg-gray-light px-6 py-4">
      @for (option of options(); track option.key) {
        <li (click)="select(option.key)" class="cursor-pointer">{{ option.label }}</li>
      }
    </ul>
  }
</div>
